import { configureStore } from '@reduxjs/toolkit'
import ProjectReducer from './Slices/ProjectSlice'
export const store = configureStore({
  reducer: {
    project: ProjectReducer
    },
})